export default "__VITE_ASSET__NS899wZf__"